import {useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../selectors/modals_action/affiliate-signup/stage';
import {AffiliateSignup} from '../../../../reducers/modals-action/actions';
import PurpleButton from '../../../components/purple-button';
import FormInput from '../../../components/form-input';
import FormCodeInput from '../../../components/form-code';
import IOS from './ios';
import IOSTutorial from './ios-tutorial';
import Android from './android';


export default ({game, close}) => {
    const [stage, setStage] = useState('main');

    if(stage === 'ios-tutorial') return <IOSTutorial setStage={setStage} />

    return (
            <div className="action-modal-body-container">
                <div className="modal-body stage-body">
                    <div className="stage-header">
                        <div className="left">
                            <div className="title">Install app to Claim Bonus</div>
                            {/* <div className="text">Add the app to your Home Screen to claim your bonus.</div> */}
                            <div className="text">Install the app to continue and claim your bonus.</div>
                        </div>
                        <div className="close" onClick={e => close()}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 18L18 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M18 18L6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </div>

                    <div className="telegram-push-image">
                        <div className="telegram-push-notification animate__delay-1s animate__animated animate__fadeInDown">
                            <div className="image"></div>
                            <div className="details">
                                <div className="notification-title">Your Bonus Is Ready 🎁</div>
                                <div className="notification-text">Tap to claim your bonus</div>
                            </div>
                        </div>
                    </div>

                    <IOS setStage={setStage} />

                    {/* <div className="buttons">
                        <div className="row">
                            <PurpleButton active={false} onClick={e => {
                                // dispatch(AffiliateSignup.verify(code));
                            }}>
                                Confirm
                            </PurpleButton>
                            <div className="button" onClick={e => {}}>
                                Change Number
                            </div>
                        </div>
                    </div> */}

                    <div className="stage-progress">
                        <div className="game-select">
                            <div className="left">
                                <div className="image">
                                    <img src={`${window.location.origin}/source/system/games/${game.slug}.png`} />
                                </div>
                                <div className="game-info">
                                    <div className="label">Game Selected</div>
                                    <div className="value">{game.name}</div>
                                </div>
                            </div>
                        </div>
                        <div className="map">
                            <div className="dot active"></div>
                            <div className="line active"></div>
                            <div className="dot active"></div>
                            <div className="line active"></div>
                            <div className="dot active"></div>
                            <div className="line"></div>
                            <div className="dot active bonus selected">
                                <img src={`${window.location.origin}/source/system/modals-action/affiliate-signup/gift.png`} />
                            </div>
                        </div>
                        <div className="stages">
                            <span>Choose game</span>
                            <span>Sign Up</span>
                            <span className="active">Notifications</span>
                            <span>Claim Bonus</span>
                        </div>
                    </div>
                </div>
            </div>
    )
}